const env = process.env;

import axios from 'axios';
import * as VueGoogleMaps from 'vue2-google-maps'
import gmapCluster from 'vue2-google-maps/dist/components/cluster'
Vue.use(VueGoogleMaps, {
  props: ['language'],
  load: {
    key: env.MIX_MAP_KEY,
    region: 'GR',
    language: window.Laravel.lang,
  },
  installComponents: false,
})

import Slick from 'vue-slick'

// const api = '/site/hartovasilion/src/js/api/locations.json';
const api_locations    = '/api/v1/locations';
import mapOpts from './imports/mapOptions'

Vue.component('LocationsMap', {
  props: ['language'],
  components: {
    gmapCluster,
    googleMap: VueGoogleMaps.Map,
    googleMarker: VueGoogleMaps.Marker,
    googleInfoWindow: VueGoogleMaps.InfoWindow,
    Slick
  },
  data() {
    return {
      lang: this.language?this.language:'el',
      sliderOpts: {
        rows: 0,
        appendArrows: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 8,
        infinite: true,
        centerMode: false,
        slidesToScroll: 1,
        speed: 800,
        responsive: [{
          breakpoint: 768,
          settings: "unslick"
        }]
      },
      locations: [],
      currentLocation: {},
      locationsListScrollable: 'down',
      intervalListId: null,
      map: mapOpts
    }
  },
  methods: {
    selectLocation(location) {
      let position = {
        "lat": location.lat,
        "lng": location.lng,
      }

      let content = {
        "title": location.name,
        "descr": location.address,
      }

      this.toggleInfoWindow(position, content, location.id);
    },
    checkScrollability() {
      let scrollable;
      let el = this.$refs.locationsList;

      if (el.offsetHeight + el.scrollTop >= el.scrollHeight) {
        scrollable = 'up';
      } else if (el.scrollTop === 0) {
        scrollable = 'down';
      } else {
        scrollable = 'both';
      }
      this.locationsListScrollable = scrollable;
    },
    scrollList(step) {
      let self = this;
      let locationsList = this.$refs.locationsList;
      this.intervalListId = setInterval(function () {
        locationsList.scrollBy(0, step);
        self.checkScrollability();
      }, 20);
    },
    cancelScroll() {
      clearInterval(this.intervalListId);
    },
    toggleInfoWindow(position, content, id) {

      this.currentLocation = this.locations.find((element) => {
        if (element.id == id) {
          return element;
        }
      });

      this.map.center = this.map.infoWindowPos = position;
      this.map.infoContent = content;

      //check if its the same marker that was selected if yes toggle
      if (this.map.currentMidx == id) {
        this.map.infoWinOpen = !this.map.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.map.infoWinOpen = true;
        this.map.currentMidx = id;
      }
    },
    slickMove(direction) {
      let self = this;
      let locationsList = this.$refs.listSlider;

      this.intervalListId = setInterval(function () {
        if (direction === 'next') {
          locationsList.next();
        } else if (direction === 'prev') {
          locationsList.prev();
        }
      }, 100);

    },
  },
  created() {
    axios.get('/'+this.lang+api_locations).then(({
      data
    }) => {
      if (true) {
        this.locations = data;

        this.$nextTick(() => {
          this.$refs.listSlider.reSlick();
        });

      } else {}
    });
  }
})


// WEBPACK FOOTER //
// ./src/js/locations.js